import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          clearInterval(timer);
          return prev;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => String(num).padStart(2, '0');
  return <div className="bg-[#7F1D1D] text-white py-3 px-6 text-center font-sans" data-id="element-16">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-3" data-id="element-17">
        <Clock className="w-5 h-5" data-id="element-18" />
        <span className="font-bold tracking-wider text-sm md:text-base uppercase" data-id="element-19">
          OFERTA LIMITADA: Termina en
        </span>
        <span className="font-mono font-bold text-lg md:text-xl tracking-wider text-yellow-300" data-id="element-20">
          {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
          {formatTime(timeLeft.seconds)}
        </span>
      </div>
    </div>;
}